import { useCallback } from "react";
import useAppDispatch from "@/core/helpers/useAppDispatch";
import useAppSelector from "@/core/helpers/useAppSelector";
import { MaximizeIcon, MinimizeIcon } from "@/shared/icons";
import { chatIsExpandedSelector, setChatExpand } from "@/domains/chat/slice";
import ChatControlButton from "@/domains/chat/components/chat/controls/ChatControlButton";

export default function ChatExpandedToggleContainer() {
  const dispatch = useAppDispatch();
  const isExpanded = useAppSelector(chatIsExpandedSelector);

  const onClickHandler = useCallback(
    () => dispatch(setChatExpand(!isExpanded)),
    [dispatch, isExpanded],
  );

  return (
    <ChatControlButton onClick={onClickHandler}>
      {isExpanded ? (
        <MinimizeIcon size={16} className="text-white/60 group-hover:text-white transition" />
      ) : (
        <MaximizeIcon size={16} className="text-white/60 group-hover:text-white transition" />
      )}
    </ChatControlButton>
  );
}
